import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { EventsProvider } from '../../providers/events/events.provider';
import { EventPage } from '../event/event';
/**
 * Generated class for the ExplorePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-explore',
  templateUrl: 'explore.html',
})
export class ExplorePage {
  search: any = "";
  events: any = [];
  constructor(
    public navCtrl: NavController, 
    public eventsProvider: EventsProvider, 
    public navParams: NavParams) {  
}

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ExplorePage');
    this.refresh();
  }

  goToEvent(event){
    this.navCtrl.push(EventPage, {event:event});
  }

  async refresh(){
    this.events = await this.eventsProvider.getEvents();
    // console.log("this.events",this.events);
  }


}



// WEBPACK FOOTER //
// ./src/pages/explore/explore.ts